{
  "fi": {
    "phoneAbbr": "Puh.",
    "emailSales": "myynti@youpret.com",
    "emailHello": "hello@youpret.com",
    "emailOffice": "office@youpret.com",
    "emailOffice1": "laskutus@youpret.com",
    "emailJobs": "jobs@youpret.com",
    "addressTitle": "Youpret Oy",
    "addressStreet": "Kauppakatu",
    "addressNumber": "17 B",
    "addressPostcode": "80100",
    "addressCity": "Joensuu",
    "addressCountry": "Suomi",
    "CEO": "Johto",
    "emailCEO": "mikko.koponen@youpret.com",
    "emailCEOShort": "mikko@youpret.com",
    "nameCEO": "Mikko Koponen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "040 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "040 706 3281",
    "titleCEO": "Toimitusjohtaja",
    "titleCEOInfo": "Myynti, sopimukset",
    "emailDOS": "",
    "emailDOSShort": "",
    "nameDOS": "",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "nameMikko": "Mikko Koponen",
    "emailMikko": "mikko.koponen@youpret.com",
    "emailMikkoShort": "mikko@youpret.com",
    "phoneMikko": "+358407063281",
    "phoneMikkoCaption": "040 706 3281",
    "titleMikko": "Johto",
    "titleMikkoInfo": "Myynti, sopimukset",
    "titleDOS": "Myyntijohtaja",
    "titleDOSInfo": "Yritysmyynti",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "titleCTO": "Teknologiajohtaja",
    "titleCTOInfo": "",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "+358407169099",
    "phoneSalesCaption": "040 7169 099",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "emailJani": "jani.kamarainen@youpret.com",
    "emailJaniShort": "jani@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "titleJani": "Tulkkauspalvelupäällikkö",
    "titleJaniInfo": "",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "titleLaura": "Asiantuntija, tulkkaus- ja henkilöstöpalvelut",
    "titleLauraInfo": "",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "0406403600",
    "phoneNeaCaption": "040 640 3600",
    "titleNea": "Asiakaspalvelupäällikkö",
    "titleNeaInfo": "",
    "customerServiceNea": "(Asiakaspalvelu)",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 400 169 278",
    "customerServiceSwedish": "+358454908250",
    "customerServiceSwedishCaption": "045 490 8250",
    "titleSuvi": "Asiantuntija, asiakasneuvonta",
    "titleSuviInfo": "",
    "nameCOO": "Maya Rytkönen",
    "emailMaya": "maya.rytkonen@youpret.com",
    "emailMayaShort": "maya@youpret.com",
    "MayaInfo": "(Vanhempainvapaalla)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "040 014 9295",
    "titleMaya": "Operatiivinen johtaja",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "phoneAbrial": "+358456688113",
    "phoneAbrialCaption": "",
    "titleAbrial": "Kehityspäällikkö",
    "titleAbrialInfo": "Raportointi",
    "customerSupportCaption": "Tilaukset / asiakaspalvelu",
    "customerService": "+358456688113",
    "customerServiceCaption": "045 668 8113",
    "customerServiceInSwedish": "Asiakaspalvelu ruotsiksi",
    "phoneOlga": "+358406325979",
    "phoneOlgaCaption": "+358 406 325 979",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "0400254410",
    "phoneNeaKolmonenCaption": "040 025 4410",
    "titleNeaKolmonen": "Markkinointi- ja viestintäpäällikkö",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "040 181 6692",
    "titleTanja": "Kasvu- ja liiketoimintapäällikkö",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "Vastuullisuuskoordinaattori",
    "translationsEmail": "kaannokset@youpret.com",
    "nameVerttiK": "Vertti Kypärä",
    "phoneVertti": "+358407169099",
    "phoneVerttiCaption": "040 716 9099",
    "tittleVertti": "Myyntikoordinaattori",
    "tittleVertti2": "Myynti, tarjoukset",
    "salesTittle": "Myynnin yhteistiedot",
    "salesText": "Haluatko kuulla tulkkauspalveluistamme lisää tai pyytää tarjouksen?",
    "appointement": "ajanvaraus@youpret.com",
    "phoneInterpreter": "+358454902468",
    "phoneInterpreterCaption": "045 490 2468",
    "quality": "Sopimusasiakkaat, laatu ja raportointi",
    "growth": "Liiketoiminnan kehitys ja talous",
    "technology": "Teknologia ja alustan myynti",
    "marketing": "Markkinointi, viestintä ja kumppanuudet",
    "thankYou": "Vastaamme sinulle mahdollisimman pian. Kiireellisissä asioissa olethan yhteydessä asiakaspalveluumme: 045 668 8113.",
    "applyEmail": "apply@youpret.com",
    "orderTranslationPhone": "040 632 5979",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "emailAida": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "headerEmail": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiKFi": "",
    "phoneAccounting": "",
    "phoneAccounting1": "",
    "phoneAccountingCaption": "",
    "phoneLaura": "",
    "phoneLauraCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "utc": ""
  },
  "en": {
    "phoneAbbr": "TEL",
    "emailSales": "sales@youpret.com",
    "emailHello": "hello@youpret.com",
    "emailOffice": "office@youpret.com",
    "emailOffice1": "laskutus@youpret.com",
    "emailJobs": "jobs@youpret.com",
    "addressTitle": "Youpret Oy",
    "addressStreet": "Kauppakatu",
    "addressNumber": "17 B",
    "addressPostcode": "80100",
    "addressCity": "Joensuu",
    "addressCountry": "FINLAND",
    "titleDOS": "Director of Sales",
    "titleDOSInfo": "Sales",
    "nameDOS": "",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "CEO": "Management",
    "titleCEO": "CEO",
    "titleCEOInfo": "",
    "emailCEO": "mikko.koponen@youpret.com",
    "emailCEOShort": "mikko@youpret.com",
    "nameCEO": "Mikko Koponen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "CTO",
    "titleCTOInfo": "",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "nameCOO": "Maya Rytkönen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "+358 40 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "+358407169099",
    "phoneSalesCaption": "+358 40 716 9099",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Interpreter and client manager",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Customer service manager",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "emailMayaShort": "maya@youpret.com",
    "MayaInfo": "(On parental leave)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 40 014 9295",
    "titleMaya": "COO",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "+358456688113",
    "customerServiceCaption": "+358 45 668 8113",
    "titleAbrial": "Development manager",
    "titleAbrialInfo": "Reporting",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "phoneLaura": "+358456688113",
    "phoneLauraCaption": "+358 45 668 8113",
    "titleLaura": "Expert, interpreter and staffing services",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 400 169 278",
    "titleSuvi": "Customer Advisor",
    "titleSuviInfo": "",
    "customerSupportCaption": "Customer service",
    "customerServiceInSwedish": "Customer service in Swedish",
    "customerServiceSwedish": "+358454908250",
    "customerServiceSwedishCaption": "+358 45 490 8250",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Marketing and communications manager",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 40 181 6692",
    "titleTanja": "Growth and Business Manager",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "Sustainability Coordinator",
    "phoneAccounting": "+358 40 014 9478",
    "phoneAccountingCaption": "040 014 9478",
    "phoneAccounting1": "040 014 9478",
    "translationsEmail": "translations@youpret.com",
    "nameVerttiK": "Vertti Kypärä",
    "phoneVertti": "+358407169099",
    "phoneVerttiCaption": "+358 40 716 9099",
    "tittleVertti": "Sales Coordinator",
    "tittleVertti2": "Sales, offers",
    "salesTittle": "Sales contact details",
    "salesText": "Would you like to hear more about our services or make an offer request?",
    "appointement": "ajanvaraus@youpret.com",
    "phoneInterpreter": "+358454902468",
    "phoneInterpreterCaption": "+358 45 490 2468",
    "quality": "Contractual customers, quality and reporting",
    "growth": "Business management and finances",
    "technology": "Technology and platform sales",
    "marketing": "Marketing, communications and partnerships",
    "thankYou": "Thank you for contacting us! We will reply to you within 24 hours. For urgent matters, please contact our customer service: +358 45 668 8113.",
    "orderTranslationPhone": "040 632 5979",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceNea": "",
    "emailAida": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "headerEmail": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "utc": ""
  },
  "ru": {
    "phoneAbbr": "Puh.",
    "emailSales": "myynti@youpret.com",
    "emailHello": "hello@youpret.com",
    "emailOffice": "office@youpret.com",
    "emailOffice1": "laskutus@youpret.com",
    "emailJobs": "jobs@youpret.com",
    "addressTitle": "Youpret Oy",
    "addressStreet": "Kauppakatu",
    "addressNumber": "17 B",
    "addressPostcode": "80100",
    "addressCity": "Joensuu",
    "CEO": "Руководство",
    "emailCEO": "mikko.koponen@youpret.com",
    "emailCEOShort": "mikko@youpret.com",
    "nameCEO": "Микко Копонен",
    "nameCEOFi": "(фин. Mikko Koponen)",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCEO": "Генеральный директор",
    "titleCEOInfo": "Продажи, контракты",
    "emailDOS": "",
    "emailDOSShort": "",
    "nameDOS": "",
    "nameCOO": "Майя Рютконен",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "titleDOS": "Myyntijohtaja",
    "titleDOSInfo": "Продажи",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Хейкки Вепсяляйнен",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "+358 40 189 8688",
    "titleCTO": "Технический директор",
    "titleCTOInfo": "",
    "nameSales": "Хейкки Вепсяляйнен",
    "phoneSales": "+358400149295",
    "phoneSalesCaption": "+358 40 014 9295",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Яни Кямяряйнен",
    "nameJaniFi": "(фин. Jani Kämäräinen)",
    "emailJani": "jani.kamarainen@youpret.com",
    "emailJaniShort": "jani@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "titleJani": "Менеджер службы устных переводов",
    "titleJaniInfo": "",
    "nameNea": "Нэа Руотсалайнен",
    "nameNeaFi": "(фин. Nea Ruotsalainen)",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Менеджер по обслуживанию клиентов",
    "customerServiceNea": "(Служба поддержки клиентов)",
    "titleNeaInfo": "",
    "nameCOOFi": "(фин. Maya Rytkönen)",
    "emailMaya": "maya.rytkonen@youpret.com",
    "emailMayaShort": "maya@youpret.com",
    "MayaInfo": "(On parental leave)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 40 014 9295",
    "titleMaya": "Операционный директор",
    "titleMayaInfo": "",
    "nameAbrial": "Абриэль Бертель",
    "nameAbrialFi": "(фин. Abrial Bertel)",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerSupportCaption": "Служба поддержки клиентов (финский)",
    "customerService": "+358456688113",
    "customerServiceCaption": "+358 45 668 8113",
    "titleAbrial": "Менеджер по развитию",
    "titleAbrialInfo": "Отчётность",
    "nameSuvi": "Суви Кингелин",
    "nameSuviFi": "(фин. Suvi Kingelin)",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 400 169 278",
    "titleSuvi": "Специалист по обслуживанию клиентов",
    "titleSuviInfo": "",
    "nameLaura": "Лаура Косонен",
    "nameLauraFi": "(фин. Laura Kosonen)",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "titleLaura": "Специалист службы устных переводов",
    "titleLauraInfo": "",
    "nameNeaK": "Неа Колмонен",
    "nameNeaKFi": "(фин. Nea Kolmonen)",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Менеджер по маркетингу и связям с общественностью",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Таня Маджугина",
    "nameTanjaFi": "(фин. Tanja Madzhugina)",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 40 181 6692",
    "titleTanja": "Менеджер по росту и развитию бизнеса",
    "titleTanjaInfo": "",
    "nameVerttiK": "Майя Рютконен",
    "nameVerttiKFi": "(фин. Maya Rytkönen)",
    "phoneVertti": "+358400149295",
    "phoneVerttiCaption": "+358 40 014 9295",
    "tittleVertti": "Операционный директор",
    "tittleVertti2": "",
    "salesTittle": "Контакты отдела продаж",
    "salesText": "Хотите узнать больше о наших услугах устного перевода или запросить предложение?",
    "appointement": "ajanvaraus@youpret.com",
    "phoneInterpreter": "+358454902468",
    "phoneInterpreterCaption": "+358 45 490 2468",
    "quality": "Договорные клиенты, качество и отчетность",
    "growth": "Развитие бизнеса и финансы",
    "technology": "Технология и продажа платформы",
    "marketing": "Маркетинг, коммуникации и сотрудничество",
    "thankYou": "Спасибо за обращение! Мы ответим вам в течение 24 часов. По срочным вопросам, пожалуйста, свяжитесь с нашей службой поддержки клиентов: +358 45 668 8113.",
    "orderTranslationPhone": "040 632 5979",
    "addressCountry": "",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceInSwedish": "",
    "customerServiceSwedish": "",
    "customerServiceSwedishCaption": "",
    "emailAida": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "headerEmail": "",
    "nameAida": "",
    "nameSatu": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneAccounting": "",
    "phoneAccounting1": "",
    "phoneAccountingCaption": "",
    "phoneLaura": "",
    "phoneLaura2": "",
    "phoneLauraCaption": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "titleAida": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "translationsEmail": "",
    "utc": ""
  },
  "sv": {
    "phoneAbbr": "TEL",
    "emailSales": "sales@youpret.com",
    "emailHello": "hello@youpret.com",
    "emailOffice": "office@youpret.com",
    "emailOffice1": "laskutus@youpret.com",
    "emailJobs": "jobs@youpret.com",
    "addressTitle": "Youpret Oy",
    "addressStreet": "Kauppakatu",
    "addressNumber": "17 B",
    "addressPostcode": "80100",
    "addressCity": "Joensuu",
    "addressCountry": "FINLAND",
    "titleDOS": "Director of Sales",
    "titleDOSInfo": "Försäljning",
    "nameDOS": "",
    "nameCOO": "Maya Rytkönen",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "CEO": "Ledning",
    "titleCEO": "VD",
    "titleCEOInfo": "",
   "emailCEO": "mikko.koponen@youpret.com",
    "emailCEOShort": "mikko@youpret.com",
    "nameCEO": "Mikko Koponen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "CTO",
    "titleCTOInfo": "",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "+358407054377",
    "phoneSalesCaption": "+358 40 705 4377",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Tolkservicechef",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Kundservicechef",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "emailMayaShort": "maya@youpret.com",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 400 149 295",
    "titleMaya": "Operativ Chef",
    "MayaInfo": "",
    "nameAbrial": "Abrial Bartel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "+358454908250",
    "customerServiceCaption": "+358 45 490 8250",
    "utc": ", (UTC +2) 08:00 - 16:00",
    "titleAbrial": "Programutvecklare",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "titleLaura": "Specialist, Tolk- och personaltjänster",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "titleSuvi": "Kundrådgivare",
    "titleSuviInfo": "",
    "customerSupportCaption": "Kundservice",
    "phoneAccounting": "+358 40 014 9478",
    "phoneAccountingCaption": "040 014 9478",
    "phoneAccounting1": "040 014 9478",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Marknads- och kommunikationschef",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 40 181 6692",
    "titleTanja": "Tillväxt- och verksamhetschef",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "nameVerttiK": "Mira Kettunen",
    "phoneVertti": "+358406743913",
    "phoneVerttiCaption": "+358 40 647 3913",
    "tittleVertti": "Koordinator, internationella kunder",
    "tittleVertti2": "Försäljning, anbud (också på svenska)",
    "salesTittle": "Kontakta försäljningen:",
    "salesText": "Vill du höra mer om våra tolkningstjänster eller be om ett anbud?",
    "appointement": "ajanvaraus@youpret.com",
    "phoneInterpreter": "+358454908250",
    "phoneInterpreterCaption": "+358 45 490 8250",
    "quality": "Avtalskunder, kvalitet och rapportering",
    "growth": "Utveckling av verksamheten och ekonomi",
    "technology": "Teknologi och plattsformsförsäljning",
    "marketing": "Marknadsföring, kommunikation och partnerskap",
    "thankYou": "Tack för att du kontaktade oss! Vi svarar dig inom 24 timmar. Vid brådskande ärenden, vänligen kontakta vår kundtjänst: +358 45 668 8113.",
    "orderTranslationPhone": "040 632 5979",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceInSwedish": "",
    "customerServiceNea": "",
    "customerServiceSwedish": "",
    "customerServiceSwedishCaption": "",
    "emailAida": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "headerEmail": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneLaura": "",
    "phoneLaura2": "",
    "phoneLauraCaption": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "phoneSuvi": "",
    "phoneSuviCaption": "",
    "titleAbrialInfo": "",
    "titleAida": "",
    "titleMayaInfo": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "translationsEmail": ""
  },
  "de": {
    "phoneAbbr": "TEL",
    "emailSales": "sales@youpret.com",
    "emailHello": "hello@youpret.com",
    "emailOffice": "office@youpret.com",
    "emailOffice1": "laskutus@youpret.com",
    "emailJobs": "jobs@youpret.com",
    "addressTitle": "Youpret Oy",
    "addressStreet": "Kauppakatu",
    "addressNumber": "17 B",
    "addressPostcode": "80100",
    "addressCity": "Joensuu",
    "addressCountry": "FINLAND",
    "titleDOS": "Director of Sales",
    "titleDOSInfo": "Verkauf",
    "nameDOS": "",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "CEO": "Geschäftsleitung",
    "titleCEO": "Geschäftsführer",
    "titleCEOInfo": "",
    "emailCEO": "mikko.koponen@youpret.com",
    "emailCEOShort": "mikko@youpret.com",
    "nameCEO": "Mikko Koponen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "Technischer Leiter",
    "titleCTOInfo": "Verkauf, Verträge",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "nameCOO": "Maya Rytkönen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "+358406743913",
    "phoneSalesCaption": "+358 40 674 3913",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Leiter der Dolmetscherdienste",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Kundendienstmanagerin",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "emailMayaShort": "maya@youpret.com",
    "MayaInfo": "(Elternzeit)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 40 014 9295",
    "titleMaya": "Betriebsleitung",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "+358456688113",
    "customerServiceCaption": "+358 45 668 8113",
    "titleAbrial": "Entwicklungsleiter",
    "titleAbrialInfo": "Reporting",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "phoneLaura": "+358456688113",
    "phoneLauraCaption": "+358 45 668 8113",
    "titleLaura": "Expertin, Dolmetsch- und Personaldienstleistungen",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 40 016 9278",
    "titleSuvi": "Expertin, Kundenberatung",
    "titleSuviInfo": "",
    "customerSupportCaption": "Kundendienst auf Englisch",
    "customerServiceInSwedish": "Kundendienst auf Schwedisch",
    "customerServiceSwedish": "+358454908250",
    "customerServiceSwedishCaption": "+358 45 490 8250",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Marketing- und Kommunikationsleiterin",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 40 181 6692",
    "titleTanja": "Entwicklungs- und Betriebsleitung",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "",
    "nameVerttiK": "Mira Kettunen",
    "phoneVertti": "+358406473913",
    "phoneVerttiCaption": "+358 40 647 3913",
    "tittleVertti": "Koordinatorin, internationale Kunden",
    "tittleVertti2": "Verkauf, Angebote  (auch auf Deutsch)",
    "salesTittle": "Verkauf kontaktieren",
    "salesText": "Möchten Sie mehr über unsere Dolmetschdienstleistungen erfahren oder ein Angebot anfordern?",
    "appointement": "ajanvaraus@youpret.com",
    "phoneInterpreter": "+358406743913",
    "phoneInterpreterCaption": "+358 40 674 3913",
    "quality": "Qualität und Berichterstattung, Kunden mit Vertrag",
    "growth": "Entwicklung des Unternehmens und Finanzen",
    "technology": "Technologie und Plattformverkauf",
    "marketing": "Marketing, Kommunikation und Partnerschaft",
    "thankYou": "Vielen Dank für Ihre Kontaktaufnahme! Wir antworten Ihnen innerhalb von 24 Stunden. In dringenden Fällen wenden Sie sich bitte an unseren Kundenservice: +358 45 668 8113.",
    "orderTranslationPhone": "040 632 5979",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceNea": "",
    "emailAida": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "headerEmail": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneAccounting": "",
    "phoneAccounting1": "",
    "phoneAccountingCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "translationsEmail": "",
    "utc": ""
  },
  "is": {
    "phoneAbbr": "TEL",
    "emailSales": "info@youpret.is",
    "emailHello": "info@youpret.is",
    "emailOffice": "info@youpret.is",
    "emailJobs": "info@youpret.is",
    "addressTitle": "Youpret Ísland",
    "addressStreet": "Laugavegur",
    "addressNumber": "11",
    "addressPostcode": "101",
    "addressCity": "Reykjavík",
    "addressCountry": "ICELAND",
    "titleDOS": "Director of Sales",
    "titleDOSInfo": "Sala",
    "nameDOS": "",
    "phoneInterpreter": "5873000",
    "phoneInterpreterCaption": "587-3000",
    "phoneDOS": "",
    "appointement": "info@youpret.is",
    "phoneDOSCaption": "",
    "titleCEO": "CEO",
    "titleCEOInfo": "",
    "emailCEO": "heikki.vepsalainen@youpret.com",
    "emailCEOShort": "heikki@youpret.com",
    "nameCEO": "Heikki Vepsäläinen",
    "phoneCEO": "5873000",
    "phoneCEOCaption": "587-3000",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "CTO",
    "titleCTOInfo": "",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "nameCOO": "Maya Rytkönen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "5873000",
    "phoneSalesCaption": "587-3000",
    "emailSalesContact": "info@youpret.is",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Interpreter and client manager",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Customer service manager",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "MayaInfo": "(On parental leave)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "0400 149 295",
    "titleMaya": "COO",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "5873000",
    "customerServiceCaption": "587-3000",
    "titleAbrial": "Development manager",
    "titleAbrialInfo": "Reporting",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "phoneLaura": "+358456688113",
    "phoneLauraCaption": "+358 45 668 8113",
    "titleLaura": "Expert, interpreter and customer services",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 400 169 278",
    "titleSuvi": "Customer Advisor",
    "titleSuviInfo": "",
    "headerEmail": "Netfang:",
    "customerSupportCaption": "Símanúmer:",
    "customerServiceInSwedish": "Notendaþjónusta á sænsku",
    "customerServiceSwedish": "587-3000",
    "customerServiceSwedishCaption": "587-3000",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Marketing and communications manager",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 401 816 692",
    "titleTanja": "Financial and administration manager",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "Samfélagsábyrgðarverkefnastjóri",
    "emailAida": "aida.jodeiri@youpret.com",
    "applyEmail": "info@youpret.is",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "translationsEmail": "thydingar@youpret.is",
    "orderTranslationPhone": "587-3000",
    "thankYou": "Takk fyrir að hafa samband við okkur! Við munum svara þér eins fljótt og auðið er.Ef erindið er brýnt skaltu hafa samband við þjónustuver okkar í síma 587 3000",
    "customerServiceNea": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailMayaShort": "",
    "emailOffice1": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "growth": "",
    "marketing": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiK": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneAccounting": "",
    "phoneAccounting1": "",
    "phoneAccountingCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "phoneVertti": "",
    "phoneVerttiCaption": "",
    "quality": "",
    "salesText": "",
    "salesTittle": "",
    "technology": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "tittleVertti": "",
    "tittleVertti2": "",
    "utc": ""
  },
  "ee": {
    "phoneAbbr": "+37258989811",
    "emailSales": "info@youpret.ee",
    "emailHello": "info@youpret.ee",
    "emailOffice": "info@youpret.ee",
    "emailJobs": "info@youpret.ee",
    "addressTitle": "Youpret Estonia",
    "emailOffice1": "info@youpret.ee",
    "addressStreet": "Pärnu mnt",
    "addressNumber": "31",
    "addressPostcode": "10119",
    "addressCity": "Tallinn",
    "addressCountry": "Eesti",
    "titleDOS": "TODO",
    "titleDOSInfo": "TODO",
    "nameDOS": "TODO",
    "phoneDOS": "+37258989811",
    "phoneDOSCaption": "TODO",
    "titleCEO": "TODO",
    "titleCEOInfo": "TODO",
    "emailCEO": "info@youpret.ee",
    "emailCEOShort": "TODO",
    "nameCEO": "TODO",
    "phoneCEO": "TODO",
    "phoneCEOCaption": "TODO",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "TODO",
    "titleCTOInfo": "TODO",
    "emailCTO": "TODO",
    "emailCTOShort": "TODO",
    "nameCTO": "TODO",
    "nameCOO": "TODO",
    "phoneCTO": "+37258989811",
    "phoneCTOCaption": "TODO",
    "nameSales": "TODO",
    "phoneSales": "+37258989811",
    "phoneSalesCaption": "+37258989811",
    "emailSalesContact": "info@youpret.ee",
    "emailSalesContactShort": "TODO",
    "nameJani": "TODO",
    "titleJani": "TODO",
    "titleJaniInfo": "TODO",
    "emailJani": "TODO",
    "phoneJani": "TODO",
    "phoneJaniCaption": "TODO",
    "nameNea": "TODO",
    "emailNea": "TODO",
    "emailNeaShort": "TODO",
    "phoneNea": "TODO",
    "phoneNeaCaption": "TODO",
    "titleNea": "TODO",
    "titleNeaInfo": "TODO",
    "emailMaya": "TODO",
    "MayaInfo": "TODO",
    "phoneMaya": "TODO",
    "phoneMayaCaption": "TODO",
    "titleMaya": "TODO",
    "titleMayaInfo": "TODO",
    "nameAbrial": "TODO",
    "emailAbrial": "TODO",
    "emailAbrialShort": "TODO",
    "customerService": "TODO",
    "customerServiceCaption": "+37258989811",
    "titleAbrial": "TODO",
    "titleAbrialInfo": "TODO",
    "nameLaura": "TODO",
    "emailLaura": "TODO",
    "emailLauraShort": "TODO",
    "phoneLaura": "TODO",
    "phoneLauraCaption": "TODO",
    "titleLaura": "TODO",
    "titleLauraInfo": "TODO",
    "nameSuvi": "TODO",
    "emailSuvi": "TODO",
    "emailSuviShort": "TODO",
    "phoneSuvi": "TODO",
    "phoneSuviCaption": "TODO",
    "titleSuvi": "TODO",
    "titleSuviInfo": "TODO",
    "customerServiceInSwedish": "TODO",
    "customerServiceSwedish": "TODO",
    "customerServiceSwedishCaption": "TODO",
    "nameNeaK": "TODO",
    "emailNeaKolmonen": "TODO",
    "emailNeaKolmonenShort": "TODO",
    "phoneNeaKolmonen": "TODO",
    "phoneNeaKolmonenCaption": "TODO",
    "titleNeaKolmonen": "TODO",
    "titleNeaKolmonenInfo": "TODO",
    "nameTanja": "TODO",
    "emailTanja": "TODO",
    "emailTanjaShort": "TODO",
    "phoneTanja": "TODO",
    "phoneTanjaCaption": "TODO",
    "titleTanja": "TODO",
    "titleTanjaInfo": "TODO",
    "nameAida": "TODO",
    "titleAida": "TODO",
    "emailAida": "TODO",
    "applyEmail": "info@youpret.ee",
    "applyPhone": "+37258989811",
    "applyPhoneCaption": "+37258989811",
    "translationsEmail": "info@youpret.ee",
    "orderTranslationPhone": "+37258989811",
    "appointement": "",
    "customerServiceNea": "",
    "customerSupportCaption": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailMayaShort": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "growth": "",
    "headerEmail": "",
    "marketing": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiK": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneAccounting": "",
    "phoneAccounting1": "",
    "phoneAccountingCaption": "",
    "phoneInterpreter": "",
    "phoneInterpreterCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "phoneVertti": "",
    "phoneVerttiCaption": "",
    "quality": "",
    "salesText": "",
    "salesTittle": "",
    "technology": "",
    "thankYou": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "tittleVertti": "",
    "tittleVertti2": "",
    "utc": ""
  },
  "is-en": {
    "phoneAbbr": "TEL",
    "emailSales": "info@youpret.is",
    "emailHello": "info@youpret.is",
    "emailOffice": "info@youpret.is",
    "emailJobs": "info@youpret.is",
    "addressTitle": "Youpret Iceland",
    "addressStreet": "Laugavegur",
    "addressNumber": "11",
    "addressPostcode": "101",
    "addressCity": "Reykjavík",
    "addressCountry": "ICELAND",
    "appointement": "info@youpret.is",
    "phoneInterpreter": "5873000",
    "phoneInterpreterCaption": "587-3000",
    "titleDOS": "Director of Sales",
    "titleDOSInfo": "Sales",
    "nameDOS": "",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "titleCEO": "CEO",
    "titleCEOInfo": "",
    "emailCEO": "heikki.vepsalainen@youpret.com",
    "emailCEOShort": "heikki@youpret.com",
    "nameCEO": "Heikki Vepsäläinen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "CTO",
    "titleCTOInfo": "",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "nameCOO": "Maya Rytkönen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "5873000",
    "phoneSalesCaption": "587-3000",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Interpreter and client manager",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Customer service manager",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "MayaInfo": "(On parental leave)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 400 149 295",
    "titleMaya": "COO",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "5873000",
    "customerServiceCaption": "587-3000",
    "titleAbrial": "Development manager",
    "titleAbrialInfo": "Reporting",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "phoneLaura": "+358456688113",
    "phoneLauraCaption": "+358 45 668 8113",
    "titleLaura": "Expert, interpreter and staffing services",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 400 169 278",
    "titleSuvi": "Customer Advisor",
    "titleSuviInfo": "",
    "customerSupportCaption": "Customer service",
    "customerServiceInSwedish": "Customer service in Swedish",
    "customerServiceSwedish": "+358454908250",
    "customerServiceSwedishCaption": "+358 45 490 8250",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Marketing and communications manager",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 401 816 692",
    "titleTanja": "Financial and administration manager",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "Sustainability Coordinator",
    "phoneAccounting": "+358 40 014 9478",
    "phoneAccountingCaption": "040 014 9478",
    "phoneAccounting1": "040 014 9478",
    "translationsEmail": "thydingar@youpret.is",
    "orderTranslationPhone": "587-3000",
    "thankYou": "Thank you for contacting us! We will reply to you within 24 hours. For urgent matters, please contact our customer service: 587-3000.",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceNea": "",
    "emailAida": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailMayaShort": "",
    "emailOffice1": "",
    "emailSatu": "",
    "emailSatuShort": "",
    "growth": "",
    "headerEmail": "",
    "marketing": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSatu": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiK": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneSatu": "",
    "phoneSatuCaption": "",
    "phoneVertti": "",
    "phoneVerttiCaption": "",
    "quality": "",
    "salesText": "",
    "salesTittle": "",
    "technology": "",
    "titleSatu": "",
    "titleSatuInfo": "",
    "tittleVertti": "",
    "tittleVertti2": "",
    "utc": ""
  },
  "ee-en": {
    "phoneAbbr": "TEL",
    "emailSales": "info@youpret.ee",
    "emailHello": "info@youpret.ee",
    "emailOffice": "info@youpret.ee",
    "emailJobs": "info@youpret.ee",
    "addressTitle": "Youpret Estonia",
    "addressStreet": "Pärnu mnt",
    "addressNumber": "31",
    "addressPostcode": "10119",
    "addressCity": "Tallinn",
    "addressCountry": "Eesti",
    "appointement": "info@youpret.ee",
    "phoneInterpreter": "+37258989811",
    "phoneInterpreterCaption": "+37258989811",
    "titleDOS": "Director of Sales",
    "titleDOSInfo": "Sales",
    "nameDOS": "",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "titleCEO": "CEO",
    "titleCEOInfo": "",
    "emailCEO": "heikki.vepsalainen@youpret.com",
    "emailCEOShort": "heikki@youpret.com",
    "nameCEO": "Heikki Vepsäläinen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "CTO",
    "titleCTOInfo": "",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "nameCOO": "Maya Rytkönen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "+37258989811",
    "phoneSalesCaption": "+37258989811",
    "emailSalesContact": "heikki.vepsalainen@youpret.com",
    "emailSalesContactShort": "heikki@youpret.com",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Interpreter and client manager",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Customer service manager",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "MayaInfo": "(On parental leave)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 400 149 295",
    "titleMaya": "COO",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "+37258989811",
    "customerServiceCaption": "+37258989811",
    "titleAbrial": "Development manager",
    "titleAbrialInfo": "Reporting",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "phoneLaura": "+358456688113",
    "phoneLauraCaption": "+358 45 668 8113",
    "titleLaura": "Expert, interpreter and staffing services",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 400 169 278",
    "titleSuvi": "Customer Advisor",
    "titleSuviInfo": "",
    "customerSupportCaption": "Customer service",
    "customerServiceInSwedish": "Customer service in Swedish",
    "customerServiceSwedish": "+358454908250",
    "customerServiceSwedishCaption": "+358 45 490 8250",
    "nameSatu": "Satu Pirhonen",
    "emailSatu": "satu.pirhonen@youpret.com",
    "emailSatuShort": "satu@youpret.com",
    "phoneSatu": "+358406325979",
    "phoneSatuCaption": "+358 406 325 979",
    "titleSatu": "Account manager",
    "titleSatuInfo": "",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Marketing and communications manager",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 401 816 692",
    "titleTanja": "Financial and administration manager",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "Sustainability Coordinator",
    "phoneAccounting": "+358 40 014 9478",
    "phoneAccountingCaption": "040 014 9478",
    "phoneAccounting1": "040 014 9478",
    "translationsEmail": "info@youpret.ee",
    "orderTranslationPhone": "+37258989811",
    "thankYou": "Thank you for contacting us! We will reply to you within 24 hours. For urgent matters, please contact our customer service: 123456789.",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceNea": "",
    "emailAida": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailMayaShort": "",
    "emailOffice1": "",
    "growth": "",
    "headerEmail": "",
    "marketing": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiK": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneVertti": "",
    "phoneVerttiCaption": "",
    "quality": "",
    "salesText": "",
    "salesTittle": "",
    "technology": "",
    "tittleVertti": "",
    "tittleVertti2": "",
    "utc": ""
  },
  "ee-ru": {
    "phoneAbbr": "ТЕЛ",
    "emailSales": "info@youpret.ee",
    "emailHello": "info@youpret.ee",
    "emailOffice": "info@youpret.ee",
    "emailOffice1": "info@youpret.ee",
    "emailJobs": "info@youpret.ee",
    "addressTitle": "Youpret Estonia",
    "addressStreet": "Pärnu mnt",
    "addressNumber": "31",
    "addressPostcode": "10119",
    "addressCity": "Tallinn",
    "addressCountry": "Estonia",
    "appointement": "info@youpret.ee",
    "phoneInterpreter": "+372 526 6168",
    "phoneInterpreterCaption": "+372 526 6168",
    "titleDOS": "Отдел продаж",
    "titleDOSInfo": "Продажи",
    "nameDOS": "",
    "phoneDOS": "",
    "phoneDOSCaption": "",
    "titleCEO": "Генеральный директор",
    "titleCEOInfo": "",
    "emailCEO": "heikki.vepsalainen@youpret.com",
    "emailCEOShort": "heikki@youpret.com",
    "nameCEO": "Heikki Vepsäläinen",
    "phoneCEO": "+358401898688",
    "phoneCEOCaption": "+358 40 189 8688",
    "phoneCEONew": "+358407063281",
    "phoneCEONewCaption": "+358 40 706 3281",
    "titleCTO": "CTO",
    "titleCTOInfo": "",
    "emailCTO": "heikki.vepsalainen@youpret.com",
    "emailCTOShort": "heikki@youpret.com",
    "nameCTO": "Heikki Vepsäläinen",
    "nameCOO": "Maya Rytkönen",
    "phoneCTO": "+358401898688",
    "phoneCTOCaption": "040 189 8688",
    "nameSales": "Heikki Vepsäläinen",
    "phoneSales": "+372 526 6168",
    "phoneSalesCaption": "+372 526 6168",
    "emailSalesContact": "info@youpret.ee",
    "emailSalesContactShort": "info@youpret.ee",
    "nameJani": "Jani Kämäräinen",
    "titleJani": "Менеджер службы устных переводов",
    "titleJaniInfo": "",
    "emailJani": "jani.kamarainen@youpret.com",
    "phoneJani": "+358407054377",
    "phoneJaniCaption": "+358 40 705 4377",
    "nameNea": "Nea Ruotsalainen",
    "emailNea": "nea.ruotsalainen@youpret.com",
    "emailNeaShort": "nea@youpret.com",
    "phoneNea": "+358406403600",
    "phoneNeaCaption": "+358 40 640 3600",
    "titleNea": "Менеджер по обслуживанию клиентов",
    "titleNeaInfo": "",
    "emailMaya": "maya.rytkonen@youpret.com",
    "MayaInfo": "(В отпуске по уходу за ребенком)",
    "phoneMaya": "+358400149295",
    "phoneMayaCaption": "+358 40 014 9295",
    "titleMaya": "Операционный директор",
    "titleMayaInfo": "",
    "nameAbrial": "Abrial Bertel",
    "emailAbrial": "abrial.bertel@youpret.com",
    "emailAbrialShort": "abrial@youpret.com",
    "customerService": "+372 526 6168",
    "customerServiceCaption": "+372 526 6168",
    "titleAbrial": "Менеджер по развитию",
    "titleAbrialInfo": "Отчетность",
    "nameLaura": "Laura Kosonen",
    "emailLaura": "laura.kosonen@youpret.com",
    "emailLauraShort": "laura@youpret.com",
    "phoneLaura": "+358456688113",
    "phoneLauraCaption": "+358 45 668 8113",
    "titleLaura": "Специалист службы устных переводов",
    "titleLauraInfo": "",
    "nameSuvi": "Suvi Kingelin",
    "emailSuvi": "suvi.kingelin@youpret.com",
    "emailSuviShort": "suvi@youpret.com",
    "phoneSuvi": "+358400169278",
    "phoneSuviCaption": "+358 40 016 9278",
    "titleSuvi": "Консультант по работе с клиентами",
    "titleSuviInfo": "",
    "customerSupportCaption": "Служба поддержки клиентов",
    "customerServiceInSwedish": "Служба поддержки клиентов на шведском языке",
    "customerServiceSwedish": "+358454908250",
    "customerServiceSwedishCaption": "+358 45 490 8250",
    "nameSatu": "Satu Pirhonen",
    "emailSatu": "satu.pirhonen@youpret.com",
    "emailSatuShort": "satu@youpret.com",
    "phoneSatu": "+358406325979",
    "phoneSatuCaption": "+358 40 632 5979",
    "titleSatu": "Менеджер по работе с клиентами",
    "titleSatuInfo": "",
    "nameNeaK": "Nea Kolmonen",
    "emailNeaKolmonen": "nea.kolmonen@youpret.com",
    "emailNeaKolmonenShort": "",
    "phoneNeaKolmonen": "+358400254410",
    "phoneNeaKolmonenCaption": "+358 40 025 4410",
    "titleNeaKolmonen": "Менеджер по маркетингу и связям с общественностью",
    "titleNeaKolmonenInfo": "",
    "nameTanja": "Tanja Madzhugina",
    "emailTanja": "tanja.madzhugina@youpret.com",
    "emailTanjaShort": "tanja@youpret.com",
    "phoneTanja": "+358401816692",
    "phoneTanjaCaption": "+358 40 181 6692",
    "titleTanja": "Менеджер по финансам и административным вопросам",
    "titleTanjaInfo": "",
    "nameAida": "Aida Jodeiri",
    "titleAida": "Координатор по устойчивому развитию",
    "phoneAccounting": "+358 40 014 9478",
    "phoneAccountingCaption": "040 014 9478",
    "phoneAccounting1": "040 014 9478",
    "translationsEmail": "info@youpret.ee",
    "orderTranslationPhone": "+372 526 6168",
    "thankYou": "Благодарим за обращение! Мы ответим вам в течение 24 часов. По срочным вопросам, пожалуйста, свяжитесь с нашей службой поддержки клиентов: +372 526 6168.",
    "applyEmail": "",
    "applyPhone": "",
    "applyPhoneCaption": "",
    "customerServiceNea": "",
    "emailAida": "",
    "emailDOS": "",
    "emailDOSShort": "",
    "emailJaniShort": "",
    "emailMayaShort": "",
    "growth": "",
    "headerEmail": "",
    "marketing": "",
    "nameAbrialFi": "",
    "nameCEOFi": "",
    "nameCOOFi": "",
    "nameJaniFi": "",
    "nameLauraFi": "",
    "nameNeaFi": "",
    "nameNeaKFi": "",
    "nameSuviFi": "",
    "nameTanjaFi": "",
    "nameVerttiK": "",
    "nameVerttiKFi": "",
    "phoneAbrial": "",
    "phoneAbrialCaption": "",
    "phoneLaura2": "",
    "phoneLauraCaption2": "",
    "phoneOlga": "",
    "phoneOlgaCaption": "",
    "phoneVertti": "",
    "phoneVerttiCaption": "",
    "quality": "",
    "salesText": "",
    "salesTittle": "",
    "technology": "",
    "tittleVertti": "",
    "tittleVertti2": "",
    "utc": ""
  }
}